import {isValidNumber} from 'ramda-adjunct';

import {AuditCategory, VehicleAudit} from '../../../api/digitalCertificateApi';
import {getAuditFieldValue} from '../../../utils/getAuditFieldValue';
import {getRelatedActionsByUniqueKeys} from '../../../utils/getRelatedActionsByUniqueKeys';

type GetAuditMileageParams = {
  auditCategories: AuditCategory[];
  auditStructure: VehicleAudit['auditStructure'];
};

export function getAuditCurrentMileage(params: GetAuditMileageParams) {
  const relatedActions = getRelatedActionsByUniqueKeys({
    parentUniqueKey: 'VEHICLE_DOCUMENTATION',
    categories: params.auditStructure.categories,
  });

  const fieldValue = getAuditFieldValue({
    key: 'documentationCurrentMileage',
    relatedActions,
    auditCategories: params.auditCategories,
  });

  const currentMileage = fieldValue ? Number(fieldValue) : null;

  if (isValidNumber(currentMileage)) {
    return currentMileage;
  }

  return null;
}
